import React from 'react';
import {IndexLink, Link} from 'react-router';

class LoginPopup extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    onCloseLoginPopover(e) {
        this.props.onClose();
    }

    render() {

        return (
            <div className={"popover-login"}>
                <div className={"title"}>To {this.props.msg} on Versity, log in or create an account.</div>
                <div className={"btn-login"}><Link className="btn_v btn_confirm btn_popover_login" to="/signin">Log in</Link></div>
                <div className={"btn-or"}>or</div>
                <div className={"btn-sign"}><Link className="btn_v btn_confirm btn_popover_signup" to="/signup">Sign up</Link></div>
                <div className={"btn-sign"}><a className={"btn_v btn_confirm btn_popover_notnow"} onClick={this.onCloseLoginPopover.bind(this)}>Not Now</a></div>
            </div>
        )
    }
}

export default LoginPopup;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/LoginPopup.js
 **/